import { render, staticRenderFns } from "./ChooseFile.vue?vue&type=template&id=6e7ba6f9&scoped=true&"
import script from "./ChooseFile.vue?vue&type=script&lang=js&"
export * from "./ChooseFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7ba6f9",
  null
  
)

export default component.exports